export default __webpack_public_path__ + "static/img_1_1-1a9082dc790403388b9fdea21c105379.jpg";